import { test } from 'blue-tape';

import { cxp5Statics, cxp5ItemPaths, cxp6Statics, cxp6ItemPaths } from './cxp-statics';

const DEFAULT_CONTEXT = '[BBHOST]';

const widget = {
  name: 'my-widget',
  srcDir: '/path/to/widget',
  type: 'widget',
  files: [
    'index.html',
    'assets/icon.png',
  ],
};

const item = {
  name: 'my-feature',
  srcDir: '/path/to/item',
  type: 'feature',
  files: [
    'scripts/my-feature.js',
  ],
};

const container = {
  name: 'my-container',
  srcDir: '/path/to/container',
  type: 'container',
  files: [
    'config.xml',
  ],
};

test('unit :: cxp-statics :: item :: unknown item type', (assert) => {
  assert.throws(() => {
    cxp5ItemPaths({ srcDir: '/path/to/item', type: 'baa', files: ['a'] }, DEFAULT_CONTEXT);
  }, /Unknown item type/, 'show throw');
  assert.end();
});

test('unit :: cxp-statics :: item :: widget file paths', (assert) => {
  const itemFiles = {
    '/path/to/widget/index.html': 'widgets/[BBHOST]/my-widget/index.html',
    '/path/to/widget/assets/icon.png': 'widgets/[BBHOST]/my-widget/assets/icon.png',
  };

  const cxpItemPaths = cxp5ItemPaths(widget, DEFAULT_CONTEXT);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps a widget\'s files to cxp paths');
  assert.end();
});

test('unit :: cxp-statics :: item :: feature file paths', (assert) => {
  const itemFiles = {
    '/path/to/item/scripts/my-feature.js': 'features/[BBHOST]/my-feature/scripts/my-feature.js',
  };

  const cxpItemPaths = cxp5ItemPaths(item, DEFAULT_CONTEXT);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps a feature\'s files to cxp paths');
  assert.end();
});

test('unit :: cxp-statics :: item :: container file paths', (assert) => {
  const itemFiles = {
    '/path/to/container/config.xml': 'containers/[BBHOST]/my-container/config.xml',
  };

  const cxpItemPaths = cxp5ItemPaths(container, DEFAULT_CONTEXT);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps a container\'s files to cxp paths');
  assert.end();
});

test('unit :: cxp-statics :: multiple items :: process all', (assert) => {
  const items = [
    widget,
    item,
  ];
  const itemFiles = {
    '/path/to/widget/index.html': 'widgets/[BBHOST]/my-widget/index.html',
    '/path/to/widget/assets/icon.png': 'widgets/[BBHOST]/my-widget/assets/icon.png',
    '/path/to/item/scripts/my-feature.js': 'features/[BBHOST]/my-feature/scripts/my-feature.js',
  };

  const cxpItemPaths = cxp5Statics(items, DEFAULT_CONTEXT);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps all files from all items to cxp paths');
  assert.end();
});

test('unit :: cxp-6-statics :: item :: widget file paths', (assert) => {
  const itemFiles = {
    '/path/to/widget/index.html': 'my-widget/index.html',
    '/path/to/widget/assets/icon.png': 'my-widget/assets/icon.png',
  };

  const cxpItemPaths = cxp6ItemPaths(widget);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps a widget\'s files to cxp paths');
  assert.end();
});

test('unit :: cxp-6-statics :: item :: feature file paths', (assert) => {
  const itemFiles = {
    '/path/to/item/scripts/my-feature.js': 'my-feature/scripts/my-feature.js',
  };

  const cxpItemPaths = cxp6ItemPaths(item);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps a feature\'s files to cxp paths');
  assert.end();
});

test('unit :: cxp-6-statics :: item :: container file paths', (assert) => {
  const itemFiles = {
    '/path/to/container/config.xml': 'my-container/config.xml',
  };

  const cxpItemPaths = cxp6ItemPaths(container, DEFAULT_CONTEXT);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps a container\'s files to cxp paths');
  assert.end();
});

test('unit :: cxp-6-statics :: multiple items :: process all', (assert) => {
  const items = [
    widget,
    item,
  ];
  const itemFiles = {
    '/path/to/widget/index.html': 'my-widget/index.html',
    '/path/to/widget/assets/icon.png': 'my-widget/assets/icon.png',
    '/path/to/item/scripts/my-feature.js': 'my-feature/scripts/my-feature.js',
  };

  const cxpItemPaths = cxp6Statics(items, DEFAULT_CONTEXT);
  assert.deepEqual(cxpItemPaths, itemFiles, 'maps all files from all items to cxp paths');
  assert.end();
});
